import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { createEvent } from "../firebase/services";
import { useAuth } from "../hooks/useAuth";
import AdminAccessGate from "../components/AdminAccessGate";
import logo from "../assets/logo.png";

const EVENT_TYPES = [
  { key: "tournament", label: "Tournament", desc: "Pools, brackets, disciplines" },
  { key: "seminar", label: "Judging Seminar", desc: "Practice bouts for training judges" },
  { key: "training", label: "Training", desc: "Ad-hoc sparring & scoring" },
];

export default function CreateEvent() {
  const [eventName, setEventName] = useState("");
  const [eventType, setEventType] = useState("tournament");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { isAdmin } = useAuth();

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!eventName.trim()) return;
    setLoading(true);
    try {
      const { id } = await createEvent({
        name: eventName.trim(),
        type: eventType,
        disciplines: [],
      });
      navigate(`/event/${id}?tab=settings`);
    } catch (err) {
      console.error(err);
      alert("Failed to create event");
    }
    setLoading(false);
  };

  const canCreate = eventName.trim();

  if (!isAdmin) {
    return (
      <div className="min-h-screen p-5">
        <Link to="/" className="text-gray-600 text-sm no-underline hover:text-gray-400">← Back</Link>
        <div className="text-center mt-4 mb-6">
          <img src={logo} alt="" className="w-full max-w-xs mx-auto" />
          <div className="flex items-center gap-3 max-w-[280px] mx-auto mt-2 mb-3">
            <div className="flex-1 h-px bg-dark-500" />
            <span className="text-gray-400 text-[10px] font-display font-bold tracking-[0.25em] whitespace-nowrap">
              STUDY &bull; FENCE &bull; GROW
            </span>
            <div className="flex-1 h-px bg-dark-500" />
          </div>
          <h1 className="font-display text-2xl font-bold">Create New Event</h1>
        </div>
        <AdminAccessGate />
      </div>
    );
  }

  return (
    <div className="min-h-screen p-5">
      <Link to="/" className="text-gray-600 text-sm no-underline hover:text-gray-400">← Back</Link>
      <div className="text-center mt-4 mb-6">
        <img src={logo} alt="" className="w-full max-w-xs mx-auto" />
        <div className="flex items-center gap-3 max-w-[280px] mx-auto mt-2 mb-3">
          <div className="flex-1 h-px bg-dark-500" />
          <span className="text-gray-400 text-[10px] font-display font-bold tracking-[0.25em] whitespace-nowrap">
            STUDY &bull; FENCE &bull; GROW
          </span>
          <div className="flex-1 h-px bg-dark-500" />
        </div>
        <h1 className="font-display text-2xl font-bold">Create New Event</h1>
      </div>

      <form onSubmit={handleCreate} className="flex flex-col gap-5">
        {/* Event Name */}
        <div>
          <label htmlFor="create-event-name" className="text-xs font-bold text-gray-500 tracking-widest block mb-2 font-display">EVENT NAME</label>
          <input id="create-event-name" value={eventName} onChange={(e) => setEventName(e.target.value)}
            placeholder='e.g., "AFO Judge Training Seminar"'
            className="w-full p-3 bg-dark-800 border border-dark-500 rounded-lg text-white text-sm outline-none focus:border-gray-400" />
        </div>

        {/* Event Type */}
        <div>
          <label className="text-xs font-bold text-gray-500 tracking-widest block mb-2 font-display">EVENT TYPE</label>
          <div className="flex flex-col gap-2">
            {EVENT_TYPES.map(t => (
              <button key={t.key} type="button" aria-pressed={eventType === t.key} onClick={() => setEventType(t.key)}
                className="w-full p-3 rounded-lg border text-left cursor-pointer transition-all"
                style={{ background: eventType === t.key ? "#1a2a1a" : "#111", borderColor: eventType === t.key ? "#81C784" : "#666" }}>
                <div className="font-display text-sm font-bold" style={{ color: "#fff" }}>{t.label} {eventType === t.key && "✓ Selected"}</div>
                <div className="text-xs mt-0.5" style={{ color: "#bbb" }}>{t.desc}</div>
              </button>
            ))}
          </div>
          {eventType === "tournament" && (
            <p className="text-gray-600 text-xs mt-2">
              Add disciplines and competitors after the event is created, from the DISCIPLINES
              and FIGHTERS tabs.
            </p>
          )}
        </div>

        {/* Create */}
        <button type="submit" disabled={loading || !canCreate}
          className="w-full p-4 bg-gradient-to-br from-green-action-light to-green-action text-white font-display text-base font-bold rounded-xl tracking-wide disabled:opacity-40 border-none cursor-pointer mt-2">
          {loading ? "Creating..." : "Create Event →"}
        </button>
      </form>
    </div>
  );
}
